var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox cart-recommend-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "page-title" }, [_vm._v("推荐策略管理")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-wrap" },
            [
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("策略名称:")]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "keyword-input",
                    attrs: {
                      placeholder: "请输入策略名称",
                      maxlength: "20",
                      size: "small",
                      clearable: "",
                      "prefix-icon": "el-icon-search",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getList(1)
                      },
                    },
                    model: {
                      value: _vm.tableFrom.strategyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.tableFrom, "strategyName", $$v)
                      },
                      expression: "tableFrom.strategyName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("关联小程序:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "app-select-box",
                      attrs: {
                        size: "small",
                        placeholder: "全部",
                        clearable: "",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        "remote-method": _vm.searchCompanyAppOptions,
                        loading: _vm.companyAppLoading,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.getList(1)
                        },
                        "visible-change": _vm.handleCompanyAppVisibleChange,
                      },
                      model: {
                        value: _vm.tableFrom.companyAppId,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "companyAppId", $$v)
                        },
                        expression: "tableFrom.companyAppId",
                      },
                    },
                    _vm._l(_vm.companyAppOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.appName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("状态:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "select-box",
                      attrs: {
                        size: "small",
                        placeholder: "全部",
                        clearable: "",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.getList(1)
                        },
                      },
                      model: {
                        value: _vm.tableFrom.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "status", $$v)
                        },
                        expression: "tableFrom.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "启用", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "禁用", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.getList(1)
                    },
                  },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset-btn",
                  attrs: { type: "danger", size: "small" },
                  on: { click: _vm.resetSearch },
                },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增推荐策略")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "cart-recommend-table",
              attrs: { data: _vm.tableData.data, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "70",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (_vm.tableFrom.page - 1) * _vm.tableFrom.limit +
                                scope.$index +
                                1
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "strategyName",
                  label: "策略名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序",
                  "min-width": "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "关联小程序",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.appScope === 0
                                ? "全部"
                                : scope.row.appNames || "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "生效时间", "min-width": "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatEffectiveTime(scope.row)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                            "inactive-text": "禁用",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleStatusChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "120", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        scope.row.status !== 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("template", { slot: "empty" }, [
                _c("span", { staticClass: "el-table__empty-text" }, [
                  _vm._v("暂无数据"),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.tableFrom.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.tableFrom.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("save", {
        ref: "CartRecommendSaveRef",
        on: {
          doRefresh: function ($event) {
            return _vm.getList(1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }